/* eslint-disable eqeqeq */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { Card, Col, Container, Form, InputGroup, Row } from "react-bootstrap";
import { Button, DropDown, Input } from "../../../components";
import { useNavigate } from "react-router";
import { toast } from "react-toastify";
import { VerifyOtpModal } from "../CourtsBooking/VerifyOtpModal";
import {
  SendOtpBooking,
  ValidateBookingUser,
} from "../../../utilities/api/courtBooking";
import * as yup from "yup";
import { useAppSelector } from "../../../redux/Hooks/Hook";
import { yupResolver } from "@hookform/resolvers/yup";
import { useForm, SubmitHandler } from "react-hook-form";
import { CreateAssociateBooking } from "../../../utilities/api/associateBooking";
import { format } from "date-fns";
import {
  validateAlphanumericCharacterWithoutSequence,
  validateCharacterLength,
} from "../../../utilities/utils";
import { AssociateBookingDetailsType } from "../../../utilities/types";
import { messages } from "../../../utilities/Messages";

const getMessage = messages.associateBooking;

const initdata: any = {
  email: "",
  pincode: "",
  state: "",
  city: "",
  landmark: "",
  addressLine2: "",
  addressLine1: "",
  gender: "",
  gstNumber: "",
  lastName: "",
  firstName: "",
  companyName: ""
}

const AssociateBookingCustomerDetails = (props: any) => {
  const { associateBookingData, setAssociateBookingData, amount } = props;
  const navigate = useNavigate();
  const [totalTax, setTotalTax] = useState(0);
  const [bookingData, setBookingData] = useState(associateBookingData);
  const [existingData, setExistingData] = useState({});
  const [modalShow, setModalShow] = useState(false);
  const [message, setMessage] = useState("");
  const [disableAll, setDisableAll] = useState(true);
  const [submitButton, setSubmitButton] = useState(false);
  const [verifyButton, setVerifyButton] = useState(false);
  const [data, setData] = useState(initdata);
  useEffect(() => {
    let getTotalTax = 0;
    amount?.bookingTaxes.forEach((_tax: any) => {
      getTotalTax += _tax?.percentage;
    });

    setTotalTax(getTotalTax);
  }, [amount]);
  const schema = yup.object().shape({
    firstName: yup
      .string()
      .required(getMessage.firstName_isNotEmpty)
      .matches(
        /^[a-zA-Z .-]+$/,
        getMessage.firstName_matches
      )
      .min(3, getMessage.firstName_minLength)
      .max(30, getMessage.firstName_maxLength),
    lastName: yup
      .string()
      .required(getMessage.lastName_isNotEmpty)
      .matches(
        /^[a-zA-Z .-]+$/,
        getMessage.lastName_matches
      )
      .min(1, getMessage.lastName_minLength)
      .max(30, getMessage.lastName_maxLength),

    addressLine1: yup
      .string()
      // .required(getMessage.addressLine1_isNotEmpty)
      .notRequired()
      .max(50, getMessage.addressLine1_maxLength),
    addressLine2: yup
      .string()
      .max(50, getMessage.addressLine2_maxLength),

    landmark: yup.string().max(50, getMessage.landmark_maxLength),

    // gender: yup.string().required(getMessage.gender_isNotEmpty),
    gender: yup.string().notRequired(),
    companyName: yup
      .string()
      .required(getMessage.companyName_isNotEmpty)
      .max(60, getMessage.companyName_maxLength),

    gstNumber: yup
      .string()
      .notRequired()
      .test(
        "len",
        getMessage.gstNumber_test,
        (val) => !val || val.length === 15
      ),

    email: yup
      .string()
      .nullable()
      .required(getMessage.email_isNotEmpty)
      .matches(/^[\w-/.]+@([\w-]+\.)+[\w-]{2,4}$/, getMessage.email_matches)
      .max(70, getMessage.email_maxLength),
    pincode: yup
      .string()
      // .required(getMessage.pincode_isNotEmpty)
      .notRequired()
      .matches(/^[1-9][0-9]{5}$/, {
        message: getMessage.pincode_matches,
        excludeEmptyString: true,
      }),

    city: yup
      .string()
      // .required(getMessage.city_isNotEmpty)
      .notRequired()
      .max(50, getMessage.city_maxLength),


    state: yup
      .string()
      // .required(getMessage.state_isNotEmpty)
      .notRequired()
      .max(50, getMessage.state_maxLength),
  });

  const {
    formState: { errors },
    handleSubmit,
    register,
    reset,
  } = useForm<AssociateBookingDetailsType>({
    resolver: yupResolver(schema),
  });
  const { states } = useAppSelector((state) => state.states);

  const handleSend = async () => {
    if (bookingData.phone.length === 10) {
      const result = await SendOtpBooking({
        phone: bookingData.phone,
        otpFor: "courtBooking",
      });
      if (result?.data?.statusCode === 200) {
        setModalShow(true);
        setMessage(result.data.data.otpNumber);
      } else {
        toast.error(result.response.data.message);
      }
    } else {
      toast(getMessage.phone_matches);
    }
  };

  const handleVerifiedUser = async () => {
    setVerifyButton(true);
    const result = await ValidateBookingUser({
      phone: bookingData.phone,
      bookingType: "associate",
    });
    if (result.status === 200) {
      let data = result.data.data;
      setExistingData({
        ...bookingData,
        companyName: data.companyUser?.company?.name,
        firstName: data.firstName,
        lastName: data.lastName,
        gstNumber: data.gstNumber,
        email: data.email,
        phone: data.phone,
        addressLine1: data.address?.addressLine1,
        addressLine2: data.address?.addressLine2,
        city: data.address?.city,
        state: data.address?.state,
        country: data.address?.country || "India",
        pincode: data.address?.pincode,
        landmark: data.address?.landmark,
        latitude: null,
        longitude: null,
        gender: data.gender,
        panNumber: data?.panNumber,
        tanNumber: data?.tanNumber,
      });
    } else {
      if (!result?.response?.data?.data?.allowForBooking) {
        setDisableAll(true);
        toast.error(result.response.data.message);
      }
      setExistingData({
        ...associateBookingData,
        panNumber: "",
        tanNumber: "",
      });
    }
  };

  useEffect(() => {
    setAssociateBookingData({
      ...associateBookingData,
      phone: bookingData.phone,
    });
    setVerifyButton(false);
  }, [bookingData.phone]);

  useEffect(() => {
    setBookingData(existingData);
    reset(existingData);
  }, [existingData]);

  const [errorPanNumber, setErrorPanNumber] = useState("");
  const [errorTanNumber, setErrorTanNumber] = useState("");


  useEffect(() => {
    setData({ ...data, ...existingData })
  }, [existingData])

  const onSubmit: SubmitHandler<any> = async () => {
    setSubmitButton(true);
    let facilityId = Number(associateBookingData.facilityId);
    let sportId = Number(associateBookingData.sportId);
    let panNumber = associateBookingData.panNumber;
    let tanNumber = associateBookingData.tanNumber;
    if (panNumber != "" && panNumber.length != 10) {
      setErrorPanNumber(getMessage.pan_maxLength);
      setSubmitButton(false);
      return false;
    } else {
      setErrorPanNumber("");
      setErrorTanNumber("");
    }
    if (tanNumber != "" && tanNumber.length != 10) {
      setErrorTanNumber(getMessage.tan_maxLength);
      setSubmitButton(false);
      return false;
    } else {
      setErrorTanNumber("");
    }

    let SD = associateBookingData.startDate
      ? format(new Date(associateBookingData.startDate), "yyyy-MM-dd")
      : associateBookingData.startDate;

    let ED = associateBookingData.endDate
      ? format(new Date(associateBookingData.endDate), "yyyy-MM-dd")
      : associateBookingData.endDate;

    const createBooking = await CreateAssociateBooking({
      ...associateBookingData,
      ...data,
      startDate: SD,
      endDate: ED,
      facilityId: facilityId,
      sportId: sportId,
      panNumber: panNumber,
      tanNumber: tanNumber,
    });

    if (createBooking.status === 200) {

      navigate("/associate-booking-summary", {
        state: createBooking.data.data.id,
      });
    } else {
      toast.error(createBooking.response.data.message);
    }
    setSubmitButton(false);
  };

  const setValueWithLengthAndPositive = (
    key = "",
    value = "",
    min = 0,
    max = 0
  ) => {
    if (key == "panNumber") {
      setErrorPanNumber("");
    }
    if (key == "tanNumber") {
      setErrorTanNumber("");
    }
    if (
      validateCharacterLength(value, min, max) &&
      validateAlphanumericCharacterWithoutSequence(value)
    ) {
      setAssociateBookingData({ ...associateBookingData, [key]: value });
    }
  };

  return (
    <>
      <Container fluid className="g-0">
        <form onSubmit={handleSubmit(onSubmit)}>
          <Card>
            <Card.Body>
              <Card.Title className="text-start">Associate Booking</Card.Title>
              <Row>
                <Col lg={6}>
                  <div className="mb-3 text-start">
                    <label htmlFor="phone" className="form-label">
                      Contact Number <small className="text-danger">*</small>
                    </label>
                    <InputGroup>
                      <Input
                        value={bookingData.phone || ""}
                        type="number"
                        placeholder="Enter Contact Number"
                        id="phone"
                        name="phone"
                        className="form-control"
                        register={register}
                        required
                        onChange={(e: any) =>
                          setBookingData({
                            ...bookingData,
                            phone: e.target.value,
                          })
                        }
                        onKeyDown={(e: any) =>
                          ["e", ".", "-", "+"].includes(e.key) &&
                          e.preventDefault()
                        }
                        onKeyPress={(e: any) => {
                          if (e.key === "Enter") {
                            e.preventDefault();
                            handleSend();
                          }
                        }}
                        onWheel={(e: any) => e.target.blur()}
                      />
                      <Button
                        disabled={verifyButton}
                        onClick={handleSend}
                        type="button"
                        bname={verifyButton ? "Verified" : "Verify"}
                        name="verify"
                        id="verify"
                        className="btn btn-sm btn-primary rounded-1"
                      ></Button>
                    </InputGroup>
                    <span className="error-msg">{errors?.phone?.message}</span>
                  </div>
                </Col>
                <Col lg={6}>
                  <div className="mb-3 text-start">
                    <label htmlFor="companyName" className="form-label">
                      Associate Name <small className="text-danger">*</small>
                    </label>
                    <Input
                      disabled={
                        bookingData.companyName?.length > 0 || disableAll
                      }
                      value={bookingData.companyName || data.companyName || ""}
                      register={register}
                      onChange={(e: any) =>
                        setData({
                          ...data,
                          companyName: e.target.value,
                        })
                      }
                      required
                      type="text"
                      placeholder="Enter Associate Name"
                      id="companyName"
                      name="companyName"
                      className="form-control"
                    />
                    <span className="error-msg">
                      {errors?.companyName?.message}
                    </span>
                  </div>
                </Col>
              </Row>
              <Row>
                <Col lg={6}>
                  <div className="mb-3 text-start">
                    <label htmlFor="fname" className="form-label">
                      First Name <small className="text-danger">*</small>
                    </label>
                    <Input
                      disabled={bookingData.firstName?.length > 0 || disableAll}
                      value={bookingData.firstName || data.firstName || ""}
                      onChange={(e: any) =>
                        setData({
                          ...data,
                          firstName: e.target.value,
                        })
                      }
                      type="text"
                      placeholder="Enter First Name"
                      id="fname"
                      name="firstName"
                      className="form-control"
                      register={register}
                      required
                    />
                    <span className="error-msg">
                      {errors?.firstName?.message}
                    </span>
                  </div>
                </Col>
                <Col lg={6}>
                  <div className="mb-3 text-start">
                    <label htmlFor="lname" className="form-label">
                      Last Name <small className="text-danger">*</small>
                    </label>
                    <Input
                      disabled={bookingData.lastName?.length > 0 || disableAll}
                      value={bookingData.lastName || data.lastName || ""}
                      type="text"
                      onChange={(e: any) =>
                        setData({
                          ...data,
                          lastName: e.target.value,
                        })
                      }
                      placeholder="Enter Last Name"
                      id="lname"
                      name="lastName"
                      className="form-control"
                      register={register}
                      required
                    />
                    <span className="error-msg">
                      {errors?.lastName?.message}
                    </span>
                  </div>
                </Col>
                <Col lg={6}>
                  <div className="mb-3 text-start">
                    <label htmlFor="gstnumber" className="form-label">
                      GST Number
                    </label>
                    <Input
                      disabled={bookingData.gstNumber?.length > 0 || disableAll}
                      value={bookingData.gstNumber || data.gstNumber || ""}
                      onChange={(e: any) =>
                        setData({
                          ...data,
                          gstNumber: e.target.value,
                        })
                      }
                      type="text"
                      placeholder="Enter GST Number"
                      id="gstnumber"
                      name="gstNumber"
                      className="form-control"
                      register={register}
                    />
                    <span className="error-msg">
                      {errors?.gstNumber?.message}
                    </span>
                  </div>
                </Col>
                <Col lg={6}>
                  <div className="mb-3 text-start">
                    <label htmlFor="gender" className="form-label">
                      Gender
                      {/* <small className="text-danger">*</small> */}
                    </label>
                    <DropDown
                      disabled={bookingData.gender?.length > 0 || disableAll}
                      value={bookingData.gender || data.gender || ""}
                      name="gender"
                      id="addusergender"
                      className="form-control"
                      onChange={(e: any) =>
                        setData({
                          ...data,
                          gender: e.target.value,
                        })
                      }
                      register={register}
                      // required
                    >
                      <option hidden disabled value="">
                        Select Gender
                      </option>
                      <option value="male">Male</option>
                      <option value="female">Female</option>
                      <option value="other">Other</option>
                    </DropDown>
                    <span className="error-msg">{errors.gender?.message}</span>
                  </div>
                </Col>
                <Col lg={6}>
                  <div className="mb-3 text-start">
                    <label htmlFor="address" className="form-label">
                      Address Line 1
                      {/* <small className="text-danger">*</small> */}
                    </label>
                    <Input
                      disabled={
                        bookingData.addressLine1?.length > 0 || disableAll
                      }
                      onChange={(e: any) =>
                        setData({
                          ...data,
                          addressLine1: e.target.value,
                        })
                      }
                      value={bookingData.addressLine1 || data.addressLine1 || ""}
                      type="text"
                      placeholder="Enter Address Line 1"
                      id="addressLine1"
                      name="addressLine1"
                      className="form-control"
                      register={register}
                      // required
                    />
                    <span className="error-msg">
                      {errors?.addressLine1?.message}
                    </span>
                  </div>
                </Col>
                <Col lg={6}>
                  <div className="mb-3 text-start">
                    <label htmlFor="address" className="form-label">
                      Address Line 2
                    </label>
                    <Input
                      disabled={
                        bookingData.addressLine2?.length > 0 || disableAll
                      }
                      onChange={(e: any) =>
                        setData({
                          ...data,
                          addressLine2: e.target.value,
                        })
                      }
                      value={bookingData.addressLine2 || data.addressLine2 || ""}
                      type="text"
                      placeholder="Enter Address Line 2"
                      id="addressLine2"
                      name="addressLine2"
                      className="form-control"
                      register={register}
                      // required
                    />
                    <span className="error-msg">
                      {errors?.addressLine2?.message}
                    </span>
                  </div>
                </Col>
                <Col lg={6}>
                  <div className="mb-3 text-start">
                    <label htmlFor="address" className="form-label">
                      Landmark
                    </label>
                    <Input
                      disabled={bookingData.landmark?.length > 0 || disableAll}
                      value={bookingData.landmark || data.landmark || ""}
                      type="text"
                      onChange={(e: any) =>
                        setData({
                          ...data,
                          landmark: e.target.value,
                        })
                      }
                      placeholder="Enter landmark"
                      id="landmark"
                      name="landmark"
                      className="form-control"
                      register={register}
                      required
                    />
                    <span className="error-msg">
                      {errors?.landmark?.message}
                    </span>
                  </div>
                </Col>
                <Col lg={6}>
                  <div className="mb-3 text-start">
                    <label htmlFor="city" className="form-label">
                      City
                      {/* <small className="text-danger">*</small> */}
                    </label>
                    <Input
                      disabled={bookingData.city?.length > 0 || disableAll}
                      value={bookingData.city || data.city || ""}
                      type="text"
                      onChange={(e: any) =>
                        setData({
                          ...data,
                          city: e.target.value,
                        })
                      }
                      placeholder="Enter City"
                      id="city"
                      name="city"
                      className="form-control"
                      register={register}
                      // required
                    />
                    <span className="error-msg">{errors?.city?.message}</span>
                  </div>
                </Col>
                <Col lg={6}>
                  <div className="mb-3 text-start">
                    <label htmlFor="state" className="form-label">
                      State
                      {/* <small className="text-danger">*</small> */}
                    </label>
                    <DropDown
                      disabled={bookingData.state?.length > 0 || disableAll}
                      value={bookingData.state || data.state || ""}
                      name="state"
                      id="booking-state"
                      className="form-control"
                      register={register}
                      onChange={(e: any) =>
                        setData({
                          ...data,
                          state: e.target.value,
                        })
                      }
                      // required
                    >
                      <option hidden disabled value="">
                        Select State
                      </option>
                      {states?.map((item: any) => {
                        return (
                          <option key={item.code} value={item.name}>
                            {item.name}
                          </option>
                        );
                      })}
                    </DropDown>
                    <span className="error-msg">{errors?.state?.message}</span>
                  </div>
                </Col>
                <Col lg={6}>
                  <div className="mb-3 text-start">
                    <label htmlFor="pincode" className="form-label">
                      Pincode
                      {/* <small className="text-danger">*</small> */}
                    </label>
                    <Input
                      disabled={bookingData.pincode?.length > 0 || disableAll}
                      value={bookingData.pincode || data.pincode || ""}
                      type="number"
                      onChange={(e: any) =>
                        setData({
                          ...data,
                          pincode: e.target.value,
                        })
                      }
                      placeholder="Enter pincode"
                      id="pincode"
                      name="pincode"
                      className="form-control"
                      register={register}
                      // required
                      onWheel={(e: any) => e.target.blur()}
                    />
                    <span className="error-msg">
                      {errors?.pincode?.message}
                    </span>
                  </div>
                </Col>
                <Col lg={6}>
                  <div className="mb-3 text-start">
                    <label htmlFor="panNumber" className="form-label">
                      PAN Number
                    </label>
                    <Input
                      onChange={(e: any) => {
                        setValueWithLengthAndPositive(
                          "panNumber",
                          e.target.value,
                          0,
                          10
                        );
                      }}
                      disabled={disableAll}

                      value={
                        bookingData.panNumber || associateBookingData.panNumber || ""
                      }
                      type="text"
                      placeholder="Enter PAN Number"
                      id="panNumber"
                      name="panNumber"
                      className="form-control"
                    />
                    <span className="error-msg">{errorPanNumber}</span>
                  </div>
                </Col>
                <Col lg={6}>
                  <div className="mb-3 text-start">
                    <label htmlFor="tanNumber" className="form-label">
                      TAN Number
                    </label>
                    <Input
                      onChange={(e: any) => {
                        setValueWithLengthAndPositive(
                          "tanNumber",
                          e.target.value,
                          0,
                          10
                        );
                      }}
                      disabled={disableAll}

                      value={
                        bookingData.tanNumber || associateBookingData.tanNumber || ""
                      }
                      type="text"
                      placeholder="Enter TAN Number"
                      id="tanNumber"
                      name="tanNumber"
                      className="form-control"
                    />
                    <span className="error-msg">{errorTanNumber}</span>
                  </div>
                </Col>
              </Row>
              <Row className="align-items-end">
                <Col lg={6}>
                  <div className="mb-3 text-start">
                    <Form.Check
                      onChange={(e: any) =>
                        setAssociateBookingData({
                          ...associateBookingData,
                          isIgstTax: e.target.value,
                        })
                      }
                      label="IGST"
                      name="isIgstTax"
                      type="checkbox"
                      id="igst"
                      value={
                        associateBookingData.isIgstTax === "false"
                          ? "true"
                          : "false"
                      }
                      checked={
                        associateBookingData.isIgstTax === "false"
                          ? false
                          : true
                      }
                    />
                  </div>
                </Col>
                <Col lg={6}>
                  <div className="mb-3 text-start">
                    <label htmlFor="associate-email" className="form-label">
                      Email <small className="text-danger">*</small>
                    </label>
                    <Input
                      disabled={bookingData.email?.length > 0 || disableAll}
                      value={bookingData.email || data.email || ""}
                      type="email"
                      onChange={(e: any) =>
                        setData({
                          ...data,
                          email: e.target.value,
                        })
                      }
                      placeholder="Enter Email Address"
                      id="associate-email"
                      name="email"
                      className="form-control"
                      register={register}
                    />
                  </div>
                </Col>
              </Row>
              <Row className="text-end">
                <hr />
                <Col md={{ span: 4, offset: 8 }} className="mb-3">
                  <span className="user-info-title text-info text-uppercase mb-2">
                    Amount:{" "}
                  </span>
                  <span className="user-info">
                    <span className="rupees-symbol">&#8377;</span>{" "}
                    {amount?.subTotal?.toFixed(2) || 0}
                  </span>
                </Col>
                <Col md={{ span: 4, offset: 8 }} className="mb-3">
                  <span className="user-info-title text-info text-uppercase mb-2">
                    Total Tax({totalTax}%):{" "}
                  </span>
                  <span className="user-info">
                    <span className="rupees-symbol">&#8377;</span>{" "}
                    {amount?.totalTax?.toFixed(2) || 0}
                  </span>
                </Col>
                <Col md={{ span: 4, offset: 8 }}>
                  <span className="user-info-title text-info text-uppercase mb-2">
                    Payable Amount:{" "}
                  </span>
                  <span className="user-info">
                    <span className="rupees-symbol">&#8377;</span>{" "}
                    {Math.round(amount?.totalAmount) || 0}
                  </span>
                </Col>
              </Row>
              <hr />
              <Row>
                <Col className="text-end">
                  <Button
                    disabled={submitButton || !verifyButton}
                    type="submit"
                    bname={submitButton ? "Submiting..." : "Submit"}
                    name="next"
                    id="next"
                    className="btn btn-primary rounded-1"
                  ></Button>
                </Col>
              </Row>
            </Card.Body>
          </Card>
        </form>
      </Container>
      <VerifyOtpModal
        message={message}
        modalShow={modalShow}
        setModalShow={setModalShow}
        setMessage={setMessage}
        handleVerifiedUser={handleVerifiedUser}
        phone={bookingData.phone}
        setDisableAll={setDisableAll}
      />
    </>
  );
};
export { AssociateBookingCustomerDetails };
